import React from 'react'
import { InferGetServerSidePropsType } from 'next'
import { BuilderComponent } from '@builder.io/react'

import { getServerSideProps } from 'src/pages/builder/server'
import LandingsHeader from 'src/pages/builder/LandingHeader'
import { LandingsContainer } from 'src/pages/builder/styles'

import { SUBSCRIPTION_BOX_REVIEWS_PAGE } from 'src/constants/subscriptionSources'
import Footer from 'client/components/Footer'
import { SearchProvider } from 'src/context/search'
import { TopDestinationsProvider } from 'src/context/topDestinations'
import Page from 'src/comps/Page'
import { ReviewsHead } from 'src/pages/reviews/head'
import { SubscriptionBox } from '@s4l/uikit'

const pagePathView = '/reviews'

export { pagePathView }
export const pageId = 'reviews'

type Props = InferGetServerSidePropsType<typeof getServerSideProps>

export default (props: Props) => {
  const { config, builderContent, topDestinationsJSON } = props

  return (
    <Page config={config} pageId={pageId}>
      <ReviewsHead />
      <SearchProvider location={null}>
        <TopDestinationsProvider value={{ topDestinationsJSON }}>
          <LandingsHeader />
          <LandingsContainer>
            <BuilderComponent locale={config.locale} model="page" content={builderContent} />
          </LandingsContainer>
          <SubscriptionBox source={SUBSCRIPTION_BOX_REVIEWS_PAGE} />
          <Footer />
        </TopDestinationsProvider>
      </SearchProvider>
    </Page>
  )
}

export { getServerSideProps }
